export default __webpack_public_path__ + "static/media/changeSchedule.fb78a006.svg";